import gql from 'graphql-tag';
import Product from '../../../entity/product';

const updateProduct = gql`
  mutation updateProductForOrder(
    $orderId: IDString!
    $id: IDString
    $manageId: String
    $count: Int
  ) {
    updateProductForOrder(
      orderId: $orderId
      id: $id
      manageId: $manageId
      count: $count
    ) {
      ${Product.fragmentsFields()}
    }
  }
`;

export default updateProduct;
